/**
 * Model to reference item
 */
export class IdentityReferenceItem {
    public id: string = null;
    public name: string = null;
    public abbreviation: string = null;
    public type: string = null;
    public isDeleted: boolean = false;

    public clone<T>(): IdentityReferenceItem {
        const clone: IdentityReferenceItem = new IdentityReferenceItem();
        clone.id = this.id;
        clone.name = this.name;
        clone.abbreviation = this.abbreviation;
        clone.type = this.type;
        clone.isDeleted = this.isDeleted;

        return clone;
    }

    /**
     * Deserialize to json api format
     */
    public deserialize<T>(json: any): IdentityReferenceItem {
        const data: any = json.data || json;
        const attrs: any = data.attributes;

        this.id = data.id;
        this.name = attrs.name;
        this.abbreviation = attrs.abbreviation;
        this.type = attrs.type;
        this.isDeleted = attrs.isDeleted;

        return this;
    }
}
